import type { AvatarPhoto } from '../ui/Avatar';
import { mediaUrl } from './media-url';

/**
 * A profile photo's R2 key, as the database checks it (migration 20261103000500), the owner's id captured. Kept in
 * sync by avatar.test.ts, which reads the migration.
 */
export const AVATAR_KEY = /^o\/[0-9a-f-]{36}\/u\/([0-9a-f-]{36})\/avatar-[A-Za-z0-9_-]{22}\.webp$/;

/**
 * The only way to a photo URL (P5g): a well-formed key under this person's own id, on this build's media base. A URL,
 * a key of someone else or anything a peer's awareness made up gives no photo, so the initials (never a tracking
 * pixel, never another person's face).
 */
export function avatarPhoto(key: string | null | undefined, userId: string, base?: string): AvatarPhoto | undefined {
  if (typeof key !== 'string') return undefined;
  const m = AVATAR_KEY.exec(key);
  if (!m || m[1] !== userId) return undefined;
  return (base === undefined ? mediaUrl(key) : mediaUrl(key, base)) as AvatarPhoto;
}
